import type { Platforms, PlatformMapping } from '../api/accounts'
import { ASSETS2_URL, assets2Client } from '.'

type RecommendationMetadataPlatform = {
  [key in keyof typeof PlatformMapping]: Record<key, string>
}[keyof typeof PlatformMapping]

export type SeverityTypes = 'critical' | 'moderate' | 'low'

export type RecommendationTypes = 'errors' | 'performance' | 'best_practices'

export type OutputColumns = Record<string, { label: string; type: OutputColumnsTypes; description: string }>
export type OutputColumnsTypes = 'string' | 'number' | 'percentage'
export type DefaultColumns = string[]

type RecommendationParamTypeString = 'string' | 'regex'
type RecommendationParamTypeNumber = 'percentage' | 'number' | 'days' | 'integer'
export type RecommendationParamType = RecommendationParamTypeString | RecommendationParamTypeNumber

interface RecommendationParamBase {
  default: string | number
  type: RecommendationParamType
  label: string
  description: string
}

interface RecommendationParamNumberType extends RecommendationParamBase {
  default: number
  type: RecommendationParamTypeNumber
  min: number
  max: number
}

interface RecommendationParamStringType extends RecommendationParamBase {
  default: string
  type: RecommendationParamTypeString
}

export type RecommendationParams = Record<string, RecommendationParamNumberType | RecommendationParamStringType>

export type RecommendationStage = 'deprecated' | 'active' | 'testing'

export interface RecommendationMetadataJson {
  id: string
  platform: RecommendationMetadataPlatform
  severity: SeverityTypes
  name: string
  platform_entity_type: string
  category: RecommendationTypes
  recommendation: string
  output_columns: OutputColumns
  reports: string[]
  default_columns: DefaultColumns
  params?: RecommendationParams
  stage?: RecommendationStage
}

export type RecommendationRulesMetadataJson = Record<string, RecommendationMetadataJson>

export interface RecommendationMetadata
  extends Omit<RecommendationMetadataJson, 'platform' | 'platform_entity_type' | 'output_columns' | 'default_columns'> {
  platform: Platforms
  platformEntityType: RecommendationMetadataJson['platform_entity_type']
  outputColumns: RecommendationMetadataJson['output_columns']
  defaultColumns: RecommendationMetadataJson['default_columns']
  stage: RecommendationStage
}

export const getRecommendationsRulesMetadataJson = async (): Promise<RecommendationRulesMetadataJson> => {
  const response = await assets2Client.get<RecommendationRulesMetadataJson>({
    path: `${ASSETS2_URL}/recommendations_rules/rules.json`
  })
  return response
}

export const getRecommendationHowToFix = async (ruleId: string): Promise<string> => {
  const response = await assets2Client.get<string>({ path: `${ASSETS2_URL}/recommendations_rules/${ruleId}.md` })
  return response
}
